module.exports = __webpack_public_path__ + "img/tian.e29fa225.png";